module.exports = __webpack_public_path__ + "static/contact-d10c9a54485638be21c62a5ce296eddf.svg";